document.addEventListener("DOMContentLoaded", function () {
    var tabBtns = document.querySelectorAll(".tabs__head .tabs__btn");
    var tabContents = document.querySelectorAll(".tabs__body .tabs__content");

    if (tabBtns.length > 0 && tabContents.length > 0) {
        tabBtns.forEach(function (tabBtn, index) {
            tabBtn.addEventListener("click", function () {
                var isActive = tabBtn.classList.contains("active");

                // Remove active class from all buttons and hide all contents
                tabBtns.forEach(btn => btn.classList.remove("active"));
                tabContents.forEach(content => (content.style.display = "none"));

                // Toggle clicked tab
                if (!isActive) {
                    tabBtn.classList.add("active");
                    tabContents[index].style.display = "block";
                }
            });
        });
    }
});
